<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16.5" cy="16.5" r="15" fill="#FF0000" stroke="#FF0000" stroke-width="3"/>
<g clip-path="url(#clip0_29_2)">
<path d="M16.5 24L22.9032 17.4947C23.5822 16.806 24 15.8525 24 14.8036C24 12.7058 22.3182 11 20.25 11C18.1818 11 16.5 12.7058 16.5 14.8036C16.5 12.7058 14.8182 11 12.75 11C10.6818 11 9 12.7058 9 14.8036C9 15.8525 9.41783 16.806 10.0968 17.4947L16.5 24Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_29_2">
<rect width="15" height="13" fill="white" transform="translate(9 11)"/>
</clipPath>
</defs>
</svg>
